import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { weekdaysWithUserFirstDayOfWeek } from 'modules/core/lib/firstDayOfWeek'
import i18n from 'modules/core/lib/i18n'

import useWeekdaysName from 'modules/work_schedules/hooks/useWeekdaysName'

const TableHeader = () => {
  const {
    access: { firstDayOfWeek },
  } = useCurrentSession()
  const { shortWeekDaysName } = useWeekdaysName()

  return (
    <Table.Head>
      <Table.Row>
        <Table.Cell>
          <Box width="s140">
            <Text color="grey1000" size="200">
              {i18n.t('settings.work_schedule.table_data.period')}
            </Text>
          </Box>
        </Table.Cell>
        {weekdaysWithUserFirstDayOfWeek(firstDayOfWeek).map((str) => (
          <Table.Cell key={str} wide>
            <Box width="s64">{shortWeekDaysName[str]}</Box>
          </Table.Cell>
        ))}
      </Table.Row>
    </Table.Head>
  )
}

export default TableHeader
